<template>
  <div>
    <div class="flex justify-between items-center pb-2.5">
      <p class="text-xl font-semibold px-2.5 xl:pl-0">Tabela H2H</p>
    </div>
    <div class="bg-zt-light/35 border border-zt-light rounded-zt">
      <div class="flex justify-between w-full items-center border-b border-zt-light bg-zt-light-full py-1 pr-3 pl-2 xl:!pl-4">
        <span class="text-xs px-2.5 xl:pl-0">TABELA H2H {{ leagueDetails && leagueDetails.name ? '- '+leagueDetails.name : '' }}</span>
        <div class="flex gap-x-[6px]">
          <div class="my-auto w-[34px] !leading-[12px]">
            <span v-if="window.size.desktop"
                  class="w-[34px] uppercase text-right text-zt-more text-[10px] !leading-[12px] font-medium">
              Zmień widok
            </span>
          </div>
          <div @click="changeView()"
               class="px-2.5 py-1 flex max-h-[28px] items-center gap-x-2.5 rounded-zt border zt-hover cursor-pointer border-zt-light bg-[#3A4B64B2]">
            <div>
              <svg :class="view === 'normal' ? '' : 'opacity-40 max-h-[13px]'"
                   xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
                <rect x="0.425781" y="0.8125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                <g>
                  <rect x="2.61328" y="3.625" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="7.375" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="11.125" width="15" height="2" rx="1" fill="white"/>
                  <rect x="2.61328" y="14.875" width="15" height="2" rx="1" fill="white"/>
                </g>
              </svg>
            </div>
            <div>
              <svg
                  :class="view === 'compact' ? '' : 'opacity-40 max-h-[13px]'"
                  xmlns="http://www.w3.org/2000/svg" width="21" height="20" viewBox="0 0 21 20" fill="none">
                <rect x="0.425781" y="0.3125" width="19.375" height="19.375" rx="4.6875" stroke="white" stroke-width="0.625"/>
                <g>
                  <rect x="7.27344" y="6.87109" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="3.53906" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="10.625" width="5.98307" height="2" rx="1" fill="white"/>
                  <rect x="7.27344" y="14.375" width="5.98307" height="2" rx="1" fill="white"/>
                </g>
              </svg>
            </div>
          </div>
        </div>
      </div>
      <div v-if="window.size.mobile">
        <div class="flex items-center justify-center text-[11px] py-2.5 bg-[#283444] border-b border-zt-light rounded-t-zt">
          <div :class="{ 'bg-zt-light' : selectedTeam === teamAId }" @click="selectedTeam = this.teamAId"
               class="grid place-items-center cursor-pointer w-[114px] uppercase h-[34px] px-2 border border-r-0 border-zt-light rounded-l-[5px]">
            <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamAQueryName}.png`" width="20" height="20" :alt="teamAQueryName"/>
          </div>
          <div :class="{ 'bg-zt-light' : selectedTeam === teamBId }" @click="selectedTeam = this.teamBId"
               class="grid place-items-center cursor-pointer w-[114px] h-[34px] px-2 border border-zt-light border-l-0 rounded-r-[5px]">
            <img :src="`/wp-content/themes/zawodtyper/assets/images/druzyny/${teamBQueryName}.png`" width="20" height="20" :alt="teamBQueryName"/>
          </div>
        </div>
      </div>
      <div v-if="season_phases.length > 1 && leagueId !== 253" class="px-2 py-2.5 border-b flex gap-x-10 border-zt-light">
        <div v-if="window.size.desktop" class="w-full text-center text-xs rounded-zt border border-zt-light opacity-75 flex items-center justify-center basis-1/2">
          <span class="translate-y-px">{{ seasonsType === 'year' ? season : `${ season } / ${ +season + 1 }` }}</span>
        </div>
        <SeasonPhaseSelect :classes="'w-full !text-center rounded-zt border border-zt-light text-xs xl:basis-1/2'" :options="season_phases" :default="selected_phase.string" :model="selected_phase" />
      </div>
      <FootballStatsFilter v-if="!reloadSwiper" analytic-type="h2h" class="pt-2" :options="filteringOptions" :is-league-results="true" swiper-id="swiper2" @filtering-changed="(value) => { selectedFilters = value }"/>
      <div v-if="window.size.desktop" class="grid grid-cols-2">
        <div class="border-r border-zt-light">
          <H2hMainTable v-for="[key, data] in Object.entries(tableData[0])"
            :teams="data"
            :group="key"
            :show-crest="false"
            :view="view"
            :selectedFilters="selectedFilters"
            :show-h2h-button="false"
            :teamId="teamAId"/>
        </div>
        <div class="border-l border-zt-light">
          <H2hMainTable v-for="[key, data] in Object.entries(tableData[1])"
            :teams="data"
            :group="key"
            :view="view"
            :show-crest="false"
            :show-h2h-button="false"
            :selectedFilters="selectedFilters"
            :teamId="teamBId"/>
        </div>
      </div>
      <div v-else-if="window.size.mobile">
        <H2hMainTable v-if="selectedTeam === this.teamAId" v-for="[key, data] in Object.entries(tableData[0])"
          :teams="data"
          :group="key"
          :view="view"
          :selectedFilters="selectedFilters"
          :show-h2h-button="false"
          :teamId="teamAId"/>
        <H2hMainTable v-if="selectedTeam === this.teamBId" v-for="[key, data] in Object.entries(tableData[1])"
          :teams="data"
          :group="key"
          :view="view"
          :selectedFilters="selectedFilters"
          :show-h2h-button="false"
          :teamId="teamBId"/>
      </div>
      <Transition name="collapse">
        <div v-if="selectedFilters[0] === 'cards' && selectedFilters[2] === 'result'" class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
          <span class="inline-block w-1 h-3.5 bg-[#2AEB26] rounded-zt"></span>
          <span class="text-zt-more text-xs">Kolor zielony oznacza niechlubne zwycięstwo</span>
        </div>
      </Transition>
      <Transition name="collapse">
          <div v-if="selectedFilters[0]==='odds' && selectedFilters[1] === '1x2'" class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
            <span class="text-zt-more text-xs">Kurs na zwycięstwo zaznaczonej drużyny - rozliczenie trzydrogowe</span>
          </div>
        </Transition>
        <Transition name="collapse">
          <div v-if="selectedFilters[0]==='odds' && selectedFilters[1] === 'winLose'" class="border-t border-zt-light w-full px-3 py-3.5 flex items-center gap-2">
            <span class="text-zt-more text-xs">Kurs na zwycięstwo zaznaczonej drużyny - rozliczenie: trafony lub nietrafiony</span>
          </div>
        </Transition>
        <Transition name="collapse">
          <div v-if="selectedFilters[0]==='cleansheet'" class="border-t border-zt-light w-full px-3 py-3.5">
            <div class="flex items-center gap-2 mb-2">
              <span class="inline-block w-1 h-3.5 bg-[#2AEB26] rounded-zt"></span>
              <span class="text-zt-more text-xs">Czyste konto</span>
            </div>
            <div class="flex items-center gap-2">
              <span class="inline-block w-1 h-3.5 bg-[#CE2121] rounded-zt"></span>
              <span class="text-zt-more text-xs">Brak czystego konta</span>
            </div>
          </div>
        </Transition>
    </div>
  </div>
</template>

<script>
import FootballStatsFilter from "../components/FootballStatsFilter.vue";
import H2hMainTable from "../components/football_stats/tables/H2hMainTable.vue";
import {footballFilteringOptions} from "../../assets/js/football-filtering-options";
import FormSelect from "../components/FormSelect.vue";
import SeasonPhaseSelect from "../components/SeasonPhaseSelect.vue";
import {phaseDisplayInSelectPriority} from "../../assets/js/utils";

export default {
	name: 'FootballStatsCompareH2H',
	components: {SeasonPhaseSelect, FormSelect, H2hMainTable, FootballStatsFilter},
	inject: ["WP"],
	props: {
		leagueId: {
			type: Number,
			required: true,
		},
		teamAId: {
			type: Number,
			required: true,
		},
		teamAQueryName: {
			type: String,
			required: true
		},
		teamBQueryName: {
			type: String,
			required: true
		},
		teamBId: {
			type: Number,
			required: true,
		},
    season: {
      type: String,
    },
    seasonsType: {
      type: String,
    }
	},
	data() {
		return {
			selectedTeam: '',
			teamsA: [],
			teamsB: [],
			selectedFilters: ['table', 'all'],
      selected_phase: { string: '' },
      teamsLoaded: false,
      reloadSwiper: false,
      view: 'normal',
      clickedView: false,
      loading: true,
      leagueDetails: []
		}
	},
	async mounted() {
		const responseA = await axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_h2h_stats',
			team_id: this.teamAId,
		});
		this.teamsA = responseA.data.data;
		const responseB = await axios.post(this.WP.ajaxUrl, {
			endpoint: 'api_get_h2h_stats',
			team_id: this.teamBId,
		});
		this.teamsB = responseB.data.data;
		this.selectedTeam = this.teamAId;
    this.teamsLoaded = true;
    this.selected_phase.string = this.season_phases[this.season_phases.length - 1];
    await this.getLeagueDetails();
    this.loading = false;
	},
	computed: {
    season_phases() {
      if (this.teamsA && this.teamsB) {
        let teamAPhases = Object.keys(this.teamsA);
        let teamBPhases = Object.keys(this.teamsB);
        let teamsPhases = teamAPhases.filter(value => teamBPhases.includes(value));
        return phaseDisplayInSelectPriority.slice().filter(phase => teamsPhases.indexOf(phase) > -1);
      } else {
        return [];
      }
    },
		filteringOptions() {
			const baseOptions = [
				{
					name: 'Tabela',
					value: 'table',
					options: []
				},
				{
					name: 'Over/under',
					value: 'overunder',
					options: [
						{
							name: '0,5',
							value: 0.5,
							options: []
						},
						{
							name: '1,5',
							value: 1.5,
							options: []
						},
						{
							name: '2,5',
							value: 2.5,
							options: []
						},
						{
							name: '3,5',
							value: 3.5,
							options: []
						},
						{
							name: '4,5',
							value: 4.5,
							options: []
						},
						{
							name: '5,5',
							value: 5.5,
							options: []
						},
					]
				},
				{
					name: 'BTTS',
					value: 'btts',
					options: []
				},
				{
					name: 'Rożne',
					value: 'corners',
					options: [
						{
							name: 'Rezultat',
							value: 'result',
							options: []
						},
						{
							name: 'Over/Under',
							value: 'overunder',
							options: [
								{
									name: '7,5',
									value: 7.5,
									options: []
								},
								{
									name: '8,5',
									value: 8.5,
									options: []
								},
								{
									name: '9,5',
									value: 9.5,
									options: []
								},
								{
									name: '10,5',
									value: 10.5,
									options: []
								},
								{
									name: '11,5',
									value: 11.5,
									options: []
								},
								{
									name: '12,5',
									value: 12.5,
									options: []
								},
							]
						}
					]
				},
				{
					name: 'Kartki',
					value: 'cards',
					options: [
						{
							name: 'Żółte',
							value: 'yellow',
							options: [
								{
									name: 'Rezultat',
									value: 'result',
									options: []
								},
								{
									name: 'Over/Under',
									value: 'overunder',
									options: [
										{
											name: '1,5',
											value: 1.5,
											options: [],
										},
										{
											name: '2,5',
											value: 2.5,
											options: [],
										},
										{
											name: '3,5',
											value: 3.5,
											options: [],
										},
										{
											name: '4,5',
											value: 4.5,
											options: [],
										},
										{
											name: '5,5',
											value: 5.5,
											options: [],
										},
									],
								},
							],
						},
            {
              name: 'Czerwone',
              value: 'red',
              options: [
                {
                  name: 'Rezultat',
                  value: 'result',
                  options: [],
                },
                {
                  name: 'Over/Under',
                  value: 'overunder',
                  options: [
                    {
                      name: '0,5',
                      value: 0.5,
                      options: []
                    },
                  ],
                },
              ]
            }
					],
				},
				{
					name: 'Połowy',
					value: 'halfs',
					options: [
						{
							name: '1. Połowa',
							value: 'firsthalf',
							options: []
						},
						{
							name: '2. Połowa',
							value: 'secondhalf',
							options: []
						},
					],
				},
				{
					name: 'Czyste konto',
					value: 'cleansheet',
					options: []
				},
			];
      let leagueSpecificOptions = [];
      if (this.teamsLoaded) {
        const teamsHasOdds = Object.values(this.teamsA)[0][0]?.some((team) => {
          return team.home_match?.some((match) => match.odds !== null) ||
              team.visitor_match?.some((match) => match.odds !== null);
        });
        if (teamsHasOdds) {
          leagueSpecificOptions.push(footballFilteringOptions.Odds);
          this.reloadSwiper = true;
          setTimeout(() => {
            this.reloadSwiper = false;
          },100)
        }
      }
      if (this.teamsA.length > 0 && this.teamsB.length > 0) {
        let corners = 0;
        [...this.teamsB, ...this.teamsA].forEach((team) => {
          [...team.home_match, ...team.visitor_match].forEach((match) => {
            corners += Number(match.localteam_corners) + Number(match.visitorteam_corners);
          })
        });
        if ( corners === 0 ) {
          let index = baseOptions.findIndex(el => {
            return el.name === 'Rożne';
          })
          if (index !== -1) {
            baseOptions.splice(index, 1);
          }
        }
      }
			const [firstOption, ...options] = baseOptions;
			return [firstOption, ...leagueSpecificOptions, ...options];
		},
		tableData() {
      if (Object.keys(this.teamsA).length > 0 && Object.keys(this.teamsB).length > 0) {
        let selectedA = Object.entries(this.teamsA);
        let selectedB = Object.entries(this.teamsB);
        return [this.calculateTableData(Object.values(Object.fromEntries(selectedA.slice().filter(([key, val] = x) => {
          return key === this.selected_phase.string;
        })))[0][0]), this.calculateTableData(Object.values(Object.fromEntries(selectedB.slice().filter(([key, val] = x) => {
          return key === this.selected_phase.string;
        })))[0][0])];
      } else {
        return [[],[]];
      }
		},
		displayingStat() {
			if (this.selectedFilters[0] === 'corners') {
				return 'corners';
			}
			if (this.selectedFilters[0] === 'cards') {
				return 'cards';
			}
			if (this.selectedFilters[0] === 'halfs') {
				return this.selectedFilters[1] === 'firsthalf' ? 'firsthalf' : 'secondhalf'
			}
			return 'goals';
		},
	},
	methods: {
    changeView() {
      this.view = this.view === 'normal' ? 'compact' : 'normal';
      if (this.clickedView) {
        return;
      }
      this.countClicks('Ściśnięta KOLOROWA - filtr A-B', 'football');
      this.clickedView = true;
    },
		calculateTableData(teams) {
			let data = [];
			let upcomingMatches = [];
			teams.forEach(team => {
				data.push({
					id: +team.id,
					name: team.name,
          shortname: team.shortname,
					team_query_name: team.team_query_name,
					country_query_name: team.country_query_name,
					league_query_name: team.league_query_name,
					position: +team.position,
					points: +team.points,
					homeMatch: team.home_match,
					visitorMatch: team.visitor_match,
					group: team.group_name,
				});
				team.home_match.forEach((match) => {
					if (match.status != 'FT') {
						upcomingMatches.push(match);
					}
				});
				team.visitor_match.forEach((match) => {
					if (match.status != 'FT') {
						upcomingMatches.push(match);
					}
				});
			});
			if (upcomingMatches.length) {
				upcomingMatches.reduce((previous, current) => {
					return DateTime.fromSQL(previous.date) < DateTime.fromSQL(current.date) ? previous : current;
				}).isNextMatch = true;
			}

      if (this.leagueId !== 253) {
        data.sort((a, b) => new Date(b.date) - new Date(a.date));
        return { 'group' : data };
      }
      let groupedTeams = data.reduce((accumulator, team) => {
        if (!accumulator[team.group]) {
          accumulator[team.group] = [];
        }
        accumulator[team.group].push(team);
        return accumulator;
      }, {});

      return Object.fromEntries(Object.entries(groupedTeams).sort((a, b) => {
        return b[1].length - a[1].length;
      }));
		},
    async getLeagueDetails() {
      const response = await axios.post(this.WP.ajaxUrl, {
        endpoint: 'api_get_league_details',
        league_id: this.leagueId
        ,
      });
      this.leagueDetails = response.data.data;
    }
	},
}
</script>

<style scoped>
.collapse-enter-active,
.collapse-leave-active {
  transition: all 0.3s ease-out;
	overflow: hidden;
}
.collapse-enter-from,
.collapse-leave-to {
	padding-top: 0;
	padding-bottom: 0;
	max-height: 0;
	opacity: 0;
}

.collapse-enter-to,
.collapse-leave-from {
	max-height: 70px;
}
</style>